var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCartNav = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 48,
    viewBox: "0 0 95 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 93.75,
    height: 48,
    transform: "translate(0.75)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5997 15.8333H57.75L55.4167 24H41.8562M56.5833 28.6667H42.5833L40.25 13.5H36.75M43.75 33.3333C43.75 33.9777 43.2277 34.5 42.5833 34.5C41.939 34.5 41.4167 33.9777 41.4167 33.3333C41.4167 32.689 41.939 32.1667 42.5833 32.1667C43.2277 32.1667 43.75 32.689 43.75 33.3333ZM56.5833 33.3333C56.5833 33.9777 56.061 34.5 55.4167 34.5C54.7723 34.5 54.25 33.9777 54.25 33.3333C54.25 32.689 54.7723 32.1667 55.4167 32.1667C56.061 32.1667 56.5833 32.689 56.5833 33.3333Z",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCartNav, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cartNav.61beec9f.svg";
export { ForwardRef as ReactComponent };